import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [city, setCity] = useState(localStorage.getItem("lastCity") || "");
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState("");
  const [unit, setUnit] = useState("metric"); // metric = Celsius, imperial = Fahrenheit
  const API_KEY = "109421d77a42875f2fc54298cab06a7b"; // 🔹 Replace this with your real key

  const fetchWeather = async (cityName = city) => {
    if (!cityName) {
      setError("Please enter a city name");
      return;
    }

    try {
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${API_KEY}&units=${unit}`
      );
      if (!response.ok) throw new Error("City not found");

      const data = await response.json();
      setWeather(data);
      setError("");
      localStorage.setItem("lastCity", cityName);
    } catch (err) {
      setError(err.message);
      setWeather(null);
    }
  };

  useEffect(() => {
    if (city) fetchWeather(city);
    // eslint-disable-next-line
  }, [unit]);

  return (
    <div className={`app ${weather ? weather.weather[0].main.toLowerCase() : "default"}`}>
      <div className="card">
        <h1 className="title">🌤️ Weather App</h1>

        <div className="search-box">
          <input
            type="text"
            placeholder="Enter city..."
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
          <button onClick={() => fetchWeather()}>Search</button>
        </div>

        <div className="unit-toggle">
          <button
            className={unit === "metric" ? "active" : ""}
            onClick={() => setUnit("metric")}
          >
            °C
          </button>
          <button
            className={unit === "imperial" ? "active" : ""}
            onClick={() => setUnit("imperial")}
          >
            °F
          </button>
        </div>

        {error && <p className="error">{error}</p>}

        {weather && (
          <div className="weather-info">
            <h2>
              {weather.name}, {weather.sys.country}
            </h2>
            <img
              src={`https://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`}
              alt="icon"
            />
            <h3>{weather.weather[0].description.toUpperCase()}</h3>
            <p>
              🌡️ {weather.main.temp}°{unit === "metric" ? "C" : "F"}
            </p>
            <p>💨 Wind: {weather.wind.speed} {unit === "metric" ? "m/s" : "mph"}</p>
            <p>💧 Humidity: {weather.main.humidity}%</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
